import { createSlice } from "@reduxjs/toolkit";
import { uniq } from "lodash";

export const INITIAL_STATE = {
  report: null,
  categories: null,
  hiddenParagraphs: [],
  isLoadingCategories: false,
  isLoadingTerms: false,
  isReviewMode: false,
  sections: [],
  paragraphs: null,
  sentences: null,
  selectedParagraphIds: [],
};

const shreddingDetailSlice = createSlice({
  name: "detail",
  initialState: INITIAL_STATE,
  reducers: {
    reset() {
      return INITIAL_STATE;
    },
    setReport(state, { payload }) {
      state.report = payload;
    },
    setIsByParagraph(state, { payload }) {
      state.report.isByParagraph = Boolean(payload);
    },
    setCategories(state, { payload }) {
      state.categories = payload || null;
    },
    setHiddenParagraphs(state, { payload }) {
      state.hiddenParagraphs = uniq(payload || []);
    },
    setIsLoadingCategories(state, { payload }) {
      state.isLoadingCategories = Boolean(payload);
    },
    setSections(state, { payload }) {
      state.sections = payload || [];
    },
    setIsReviewMode: (state, action) => {
      state.isReviewMode = action.payload;
    },
    setTerms(state, { payload }) {
      if (state.report?.isByParagraph) {
        state.paragraphs = payload || null;
      } else {
        state.sentences = payload || null;
      }
    },
    setParagraphs(state, { payload }) {
      state.paragraphs = payload || null;
    },
    setSentences(state, { payload }) {
      state.sentences = payload || null;
    },
    setSelectedParagraphIds: (state, { payload }) => {
      state.selectedParagraphIds = payload || [];
    },
    updateTerms: (state, action) => {
      const { ids = [], changes = {} } = action.payload || {};

      if (!Array.isArray(ids) || ids.length === 0) return;

      if (state.report.isByParagraph) {
        state.paragraphs = state.paragraphs.map((term) =>
          ids.includes(term.paragraphId) ? { ...term, ...changes } : term
        );
      } else {
        state.sentences = state.sentences.map((term) =>
          ids.includes(`${term.paragraphId}-${term.sentenceIndex}`)
            ? { ...term, ...changes }
            : term
        );
      }
    },
  },
});

export const {
  setIsByParagraph,
  reset,
  setReport,
  setCategories,
  setHiddenParagraphs,
  setIsLoadingCategories,
  setIsReviewMode,
  setSections,
  setTerms,
  setParagraphs,
  setSentences,
  setSelectedParagraphIds,
  updateTerms,
} = shreddingDetailSlice.actions;

export default shreddingDetailSlice;
